import { TrStudentStatistics } from "./trStudentStatistics/trStudentStatistics";
import { TrStudentWinningProps } from "./trStudentWinningProps/trStudentWinningProps";
import { TrChangeInEducationStats } from "./trChangeInEducationStats/trChangeInEducationStats";
import {
  LgsCalculator,
  YksCalculator,
} from "@kunduz/feature-score-calculators";
import { CalculatorWrapper } from "./calculatorWrappers/calculatorWrapper";

export function GetStaticComponent(props: any) {
  switch (props.name) {
    case "tr-student-winning-props":
      return <TrStudentWinningProps />;
    case "tr-student-statistics":
      return <TrStudentStatistics />;
    case "tr-stats-change-in-education":
      return <TrChangeInEducationStats />;
    case "tr-yks-calculator":
      return (
        <CalculatorWrapper>
          <YksCalculator />
        </CalculatorWrapper>
      );
    case "tr-lgs-calculator":
      return (
        <CalculatorWrapper>
          <LgsCalculator />
        </CalculatorWrapper>
      );

    default:
      return <></>;
  }
}
